(() => {
  "use strict";

  const setup = (root) => {
    if (root.dataset.bienestarFaqReady === "true") return;
    root.dataset.bienestarFaqReady = "true";

    const tablist = root.querySelector('[role="tablist"]');
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    const triggers = [...root.querySelectorAll('.bienestar-faq__item h3 > button')];

    if (!tablist || !tabs.length || !panels.length) return;

    const closeAnswer = (trigger, immediate = false) => {
      const answer = document.getElementById(trigger.getAttribute("aria-controls"));
      if (!answer || trigger.getAttribute("aria-expanded") !== "true") return;

      trigger.setAttribute("aria-expanded", "false");
      answer.classList.remove("is-open");

      if (immediate || matchMedia("(prefers-reduced-motion: reduce)").matches) {
        answer.hidden = true;
        return;
      }

      answer.addEventListener(
        "transitionend",
        (event) => {
          if (event.propertyName === "grid-template-rows") answer.hidden = true;
        },
        { once: true },
      );
    };

    const closeAllAnswers = (immediate = false) => {
      triggers.forEach((trigger) => closeAnswer(trigger, immediate));
    };

    const openAnswer = (trigger) => {
      const answer = document.getElementById(trigger.getAttribute("aria-controls"));
      if (!answer) return;

      closeAllAnswers();
      trigger.setAttribute("aria-expanded", "true");
      answer.hidden = false;
      requestAnimationFrame(() => answer.classList.add("is-open"));
    };

    const openFirstAnswer = (panel) => {
      const firstTrigger = panel?.querySelector('.bienestar-faq__item h3 > button');
      if (!firstTrigger) return;

      const answer = document.getElementById(firstTrigger.getAttribute("aria-controls"));
      if (!answer) return;

      firstTrigger.setAttribute("aria-expanded", "true");
      answer.hidden = false;
      answer.classList.add("is-open");
    };

    const activateTab = (tab, focus = false) => {
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute("aria-selected", String(selected));
        item.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute("aria-controls");
      });

       closeAllAnswers(true);
       openFirstAnswer(document.getElementById(tab.getAttribute("aria-controls")));
       if (focus) tab.focus();
     };

    openFirstAnswer(panels.find((panel) => !panel.hidden) || panels[0]);

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => activateTab(tab));
    });

    tablist.addEventListener("keydown", (event) => {
      const currentIndex = tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      let nextIndex = currentIndex;
      if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % tabs.length;
      else if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      else if (event.key === "Home") nextIndex = 0;
      else if (event.key === "End") nextIndex = tabs.length - 1;
      else return;

      event.preventDefault();
      activateTab(tabs[nextIndex], true);
    });

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const panel = trigger.closest('[role="tabpanel"]');
        const firstTrigger = panel?.querySelector('.bienestar-faq__item h3 > button');
        if (trigger === firstTrigger && trigger.getAttribute("aria-expanded") === "true") return;

        if (trigger.getAttribute("aria-expanded") === "true") closeAnswer(trigger);
        else openAnswer(trigger);
      });
    });
  };

  const init = (target = document) => {
    const roots = [];
    if (target.nodeType === 1 && target.matches?.('[data-bienestar-section="preguntas"]')) roots.push(target);
    target.querySelectorAll?.('[data-bienestar-section="preguntas"]').forEach((root) => roots.push(root));
    roots.forEach(setup);
  };

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
